module.exports = __webpack_public_path__ + "public/Icons/starIcon.svg?f2672cb9";